import React from 'react';
import File from '../../File';
import { onCheckDocument } from 'src/helpers/CommonHelpers';

interface PropertyImageSectionProps {
  selectedImage: any;
  image: any;
  onChange: (update: any) => void;
}

const PropertyImageSection = ({
  selectedImage,
  image,
  onChange,
}: PropertyImageSectionProps) => {
  const handleSelectFile = (file: any): void => {
    if (!onCheckDocument(file)) return;

    onChange({ selectedImage: file });
  };

  return (
    <File
      label="Image"
      onSelect={handleSelectFile}
      files={selectedImage ? selectedImage : []}
      image={image}
      errors=""
      type="image"
    />
  );
};

export default PropertyImageSection;
